export default __webpack_public_path__ + "static/media/location.f9ee321e.jpg";